<!-- <div class="padding-top-10"> -->
<div class="hpanel contact-panel " *ngIf="!claimBusinesCard"
  [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput.status=='BLOCKED'}"
  style="margin-bottom: 0px!important;">
  <div class="panel-body minheight165 cp border-radius-top-left-right-6 border-radius-bottom-left-right-0"
    [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput.status=='BLOCKED'}"
    style="padding-top: 1rem;" (click)="BusinessData(BusinessDataInput,verifyTemplate)">

    <button *ngIf="shouldShowUnfollowButton()" class="btn btn-primary pull-right btn-xs"
      (click)="unfollow(); $event.stopPropagation();">
      Unfollow
    </button>
    <button *ngIf="shouldShowFollowButton()" class="btn btn-primary pull-right btn-xs"
      (click)="addfollower(); $event.stopPropagation();">
      Follow
    </button>
    <!-- <button *ngIf="pageName === 'b2bnetworkConnection' && connectionStatus?.status == 'REQUEST_PENDING'" type="button"
      class="btn btn-primary b-5 btn-xs pull-right">Cancel Request
    </button>
    <button *ngIf="pageName === 'b2bnetworkConnection' && connectionStatus?.status == 'REQUEST_RECEIVED'" type="button"
    class="btn btn-primary b-5 btn-xs pull-right">Accept
  </button>
    <button *ngIf="pageName === 'b2bnetworkConnection' && connectionStatus?.status == 'CONNECTED'" type="button"
      class="btn btn-primary b-5 btn-xs pull-right">Remove
    </button>
    <button *ngIf="pageName === 'b2bnetworkConnection' && connectionStatus?.status == 'NOT_CONNECTED'" type="button"
      class="btn btn-primary b-5 btn-xs pull-right">Connect
      <ng-icon name="tablerMail" class="jwsk" *ngIf="connectionStatus?.status == 'CONNECTED'"  aria-hidden="true"></ng-icon>
    </button> -->
    <div class="iconAliment" *ngIf="BusinessDataInput.claimable === true">
      <button (click)="claimBusiness(BusinessDataInput);$event.stopPropagation();"
        class="btn btn-xs not-verified ">Claim</button>
    </div>

    <div *ngIf="Showsuitcase " class="iconAliment">
      <div *ngIf="BusinessDataInput?.isSuperAdmin === true &&  BusinessDataInput?.businessStatus === 'VERIFIED'">
        <span><img class="crown" title="Owner" src="assets/icon/crown_.PNG" alt=""></span>
      </div>
      <div *ngIf="BusinessDataInput?.isAdmin === true && BusinessDataInput?.businessStatus === 'VERIFIED'">
        <span><img class="admincrown" title="Admin" src="assets/icon/admin_cogs.PNG" alt=""></span>
      </div>
      <div *ngIf="BusinessDataInput?.isSuperAdmin === true  && BusinessDataInput?.businessStatus === 'NOT VERIFIED'">
        <button (click)="verifyBusiness(verifyTemplate, BusinessDataInput);$event.stopPropagation();"
          class="btn btn-xs not-verified ">Verify</button>
      </div>

    </div>
    <div></div>


    <div class="plazxzl">
      <img alt="logo"
        [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput?.status=='BLOCKED'}"
        class="img-circle m-b mb-15 Bphoto" src="{{ BusinessDataInput?.businessLogo }}"
        onerror="this.src='assets/images/gallery/company.png';" />

      <div class="oyoyo">
        <img *ngIf="BusinessDataInput?.status=='INACTIVE'"
          [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput?.status=='BLOCKED'}"
          height="25px" src="assets/icon/Blocked-PNG-File.png" alt="">
        <p *ngIf="BusinessDataInput?.status=='INACTIVE'">Deactivated</p>
        <p *ngIf="BusinessDataInput?.status=='BLOCKED'">Blocked</p>
      </div>
    </div>


    <div *ngIf="BusinessDataInput?.isSuperAdmin==true && BusinessDataInput?.businessStatus != 'NOT VERIFIED'"
      class="iewbdl" id="the-dropdown" dropdown (click)="$event.stopPropagation();">
      <a id="button-animated" dropdownToggle class="m-r-10">
        <img src="assets/icon/icon-vert-thr-dot.png" alt="" height="25px" srcset="">
      </a>
      <ul id="dropdown-animated" id="the-dropdowns" *dropdownMenu class="dropdown-menu zloipfhh m-l-81" role="menu"
        aria-labelledby="button-animated">
        <li *ngIf="BusinessDataInput?.status=='INACTIVE'" role="menuitem" dropdown>
          <a class="dropdown-item common-font-12 padd" dropdownToggle
            (click)="activate(BusinessDataInput);$event.stopPropagation();">Activate Business</a>
        </li>
        <li *ngIf="BusinessDataInput?.status=='ACTIVE'" role="menuitem" dropdown>
          <a class="dropdown-item common-font-12 padd" dropdownToggle
            (click)="deactivate(BusinessDataInput);$event.stopPropagation();">Deactivate Business</a>
        </li>
      </ul>
    </div>

    <!-- <h4 class="cardEillpise  mt-23 font-bold" (click)="BusinessData(BusinessDataInput)"> -->
    <h6 class="cardEillpise card-title-font mt-23 font-bold mbss" data-toggle="tooltip" data-placement="top"
      title="{{BusinessDataInput?.businessName}}"
      [ngClass]="{'deactivated': BusinessDataInput?.status=='INACTIVE' && BusinessDataInput?.isSuperAdmin==false,'deactivatedaa':BusinessDataInput?.status=='BLOCKED'}">
      {{ BusinessDataInput?.businessName }}
    </h6>

    <!-- <div *ngIf="BusinessDataInput.isAdmin !== true && BusinessDataInput.isSuperAdmin !== true && BusinessDataInput.businessStatus === 'VERIFIED'
      && BusinessDataInput.ownerFullName">
      <p class="sdjfhj">By {{BusinessDataInput.ownerFullName}}</p>
    </div> -->

    <!-- <div class="text-muted cardEillpise common-font-11 " data-toggle="tooltip" data-placement="top"
      title="{{BusinessDataInput.facilityPracticeType}}">
      {{ BusinessDataInput.facilityPracticeType }}
    </div> -->
    <div class="text-muted cardEillpise common-font-11 " data-toggle="tooltip" data-placement="top"
      title="{{IndustryClassifications}}">
      {{IndustryClassifications}}
    </div>
    <div class="text-muted ellipse common-font-11  mb-15" data-toggle="tooltip" data-placement="top"
      title="{{BusinessDataInput?.businessLocation}}">
      {{ BusinessDataInput?.businessLocation}}
    </div>
  </div>
  <div class="panel-footer border-radius-top-left-right-0 lsjdo contact-footer footPadding">
      <div class="col-md-4 p-0">
        <div class="contact-stat">
          <span>Employees</span>
          <strong>{{ BusinessDataInput?.empCnt ?? BusinessDataInput?.employeesCnt ?? 0 }}</strong>
        </div>
      </div>
      <div class="col-md-4 p-0">
        <div class="contact-stat">
          <span>Followers </span>
          <strong>{{ BusinessDataInput?.followerCnt ?? BusinessDataInput?.followersCnt ?? 0 }}</strong>
        </div>
      </div>
      <div class="col-md-4 p-0">
        <div class="contact-stat">
          <span>Posts </span> <strong>{{ BusinessDataInput?.postCnt ?? 0 }}</strong>
        </div>
      </div>
  </div>
</div>
<!-- </div> -->

<ng-template #verifyTemplate>
  <div class="hpanel ">
    <div class="panel-body body-pad" style="border-radius: 5px;">
      <div class="common-header-flex mb-20 m-1">
        <div>Authorization Code</div>
        <button>
          <span class="common-close" (click)="onHidden()">&times;</span>
        </button>
      </div>
      <div class="modal-body body-pad1" *ngIf="!offlineVerificationFlag">
        <p>An authorization code has been sent to your business email address.</p><br>
        <p>Please check your business email and enter the authorization code below. Note that the authorization code is
          only valid for 10 minutes.</p>
      </div>
      <div class="modal-body body-pad1" *ngIf="offlineVerificationFlag">
        <p>An authorization code has been sent through post to your business address.
          Please enter the code received below. If you haven't received code, please wait for the said business days.
        </p>
        <p>Note: Delivery time may vary depending on your business location.</p>
      </div>
      <form [formGroup]="OTPConfirm" class="input-margi">
        <div class="app-form">
          <div class="row">
            <div class="form-group">
              <div class="col-sm-6">
                <input formControlName="otp" placeholder="Enter code here" (keydown)="onKeyDown()"
                  class="form-control input-sm">
                <div class="error-msg" *ngIf="disable&& otpControl.otp.invalid ||
                                  otpControl.otp.invalid &&
                                  (otpControl.otp.dirty || otpControl.otp.touched)">
                  <div *ngIf="otpControl.otp.errors.required"> Please enter the authorization code</div>
                  <div *ngIf="otpControl.otp.errors.pattern"> Please remove whitespaces</div>

                </div>
                <div class="error-msg">
                  <div *ngIf="incorrectOtp">
                    Incorrect code. Please enter the right one.
                  </div>
                  <div *ngIf="otpExpiredFlag">
                    Code expired. Please hit Resend.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row" style="margin-left: 22px" *ngIf="!offlineVerificationFlag">
        <div class="pull-left">
          <div>
            <a role="button" *ngIf="!resendCodeFlag" (click)="sendAnotherCode(BusinessDataInput.businessId)">Resend
              code</a>
            <!-- <a role="button" class="disabled" *ngIf="resendCodeFlag">Request another code in + {{" "}}</a> -->
            <!-- <span *ngIf="resendCodeFlag">
              <countdown [config]="{leftTime: 599, format: 'mm:ss'}" (event)="onTimeUp($event)">
              </countdown>
            </span> -->
          </div>

          <p *ngIf="resendCodeFlag" style="color: #c3002f;">
            Another code has been sent to your business email address. Please enter the code.
          </p>

        </div>
      </div>

      <div class="row" style="margin-left:400px;padding-bottom: 6px;">
        <div class="col otp">
          <button style="margin-right:5px;" (click)="onHidden()" class="btn btn-default">Cancel</button>
          <button (click)="navigate()" [disabled]="!OTPConfirm.valid" class="btn primary-btn ">Continue</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
